import {
  ADMIN,
  EVALUATION_IND_VIEWER,
  EVALUATION_PRG_VIEWER,
  SURVEY_VIEWER,
  TEMPLATE_VIEWER
} from "../common/constant";

export default class UserUtils {
  static baseUserPath = "/userArea/";

  static getUserHome(roles) {
    let index = "profile";

    if (!!roles.find((r) => r === ADMIN)) {
      index = "templates";
    } else if (!!roles.find((r) => r === SURVEY_VIEWER)) {
      index = "respondentsOverview";
    } else if (!!roles.find((r) => r === TEMPLATE_VIEWER)) {
      index = "templates";
    } else if (!!roles.find((r) => r === EVALUATION_IND_VIEWER)) {
      index = "reports/charts";
    } else if (!!roles.find((r) => r === EVALUATION_PRG_VIEWER)) {
      index = "reports/tables";
    }

    return `${UserUtils.baseUserPath}${index}`;
  }
}
